import { daysSince } from './time';

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

export const computeNetworkHealth = ({ members, relationships }) => {
  const activeMembers = members.filter((member) => {
    const days = daysSince(member.lastContactAt);
    return days !== null && days <= 30;
  });
  const activeScore = clamp(activeMembers.length, 0, 10);

  const roleCounts = members.reduce((acc, member) => {
    if (!member.role) return acc;
    const role = member.role.toLowerCase();
    acc[role] = (acc[role] || 0) + 1;
    return acc;
  }, {});
  const roleScore = clamp(Object.keys(roleCounts).length, 0, 5);

  const conflictCount = relationships.filter((relationship) => relationship.conflictFlag).length;
  const conflictPenalty = -clamp(conflictCount, 0, 3);

  const score = activeScore + roleScore + conflictPenalty;

  return {
    score,
    summary: {
      activeMembers: activeMembers.length,
      activeScore,
      roleScore,
      conflictPenalty,
      conflicts: conflictCount,
      totalMembers: members.length
    },
    roleCounts
  };
};

export const categorizeActivity = (member) => {
  const days = daysSince(member.lastContactAt);
  if (days === null) return 'unknown';
  if (days <= 30) return 'active';
  if (days <= 60) return 'warming';
  if (days <= 90) return 'cooling';
  return 'inactive';
};
